import {Directive, forwardRef} from '@angular/core';
import {NG_VALIDATORS} from '@angular/forms';
import {validateTsfr} from '@atlas/businesstypes';

import {AbstractValidatorDirective} from '../base/validator';

/**
 * @ngModule BusinessTypesModule
 */
@Directive({
  selector: '[atlasTsfr]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => BaseTsfrValidator),
      multi: true,
    },
  ],
})
export class BaseTsfrValidator extends AbstractValidatorDirective {
  protected readonly validatorFn = validateTsfr;
}
